import { EstimateCard, isEstimate } from "@views/EstimateCard";
import { ViewRenderer } from "@views/ViewRenderer";
import type { View } from "@views/viewsClient";

/**
 * A view's body, resolved by kind. A plain view renders its `root` a2ui tree.
 * An estimate (BE-2035) keeps its line items only in `items`, never in `root`,
 * and renders as one `EstimateCard` — editable while open, read-only once
 * signed.
 *
 * `frameless` drops the card frame, for a host that is itself the reading surface
 * (`ViewReader`).
 */
export const ViewBody = ({
  view,
  frameless = false,
}: {
  view: View;
  frameless?: boolean;
}) => {
  if (isEstimate(view))
    return (
      <EstimateCard
        view={view}
        readOnly={view.status === "signed"}
        frameless={frameless}
      />
    );

  return <ViewRenderer view={view} frameless={frameless} />;
};
